import { ColumnWidth, LayoutColumn, LayoutRow } from "./types";

let counter = 0;

export const generateId = (): string => {
  counter += 1;
  return `${Date.now()}-${counter}-${Math.random().toString(36).slice(2, 8)}`;
};

export const formatWidth = (width: ColumnWidth): string => {
  if (width.unit === "auto") return "auto";
  return `${width.value}${width.unit}`;
};

export const formatWidthLabel = (width: ColumnWidth): string => {
  if (width.unit === "auto") return "auto";
  return `${width.value}${width.unit}`;
};

export const createColumn = (width: ColumnWidth): LayoutColumn => ({
  id: generateId(),
  width,
  mobileConfig: { visible: true },
  sections: [],
});

export const createRow = (columns: LayoutColumn[], gap = 24): LayoutRow => ({
  id: generateId(),
  columns,
  gap,
});

export const buildGridTemplateColumns = (columns: LayoutColumn[]): string => {
  return columns.map((col) => formatWidth(col.width)).join(" ");
};
